import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import { Field } from "formik";
import Spinner from "web/components/Spinner";
import TextArea from "web/components/form-elements/TextArea";
import NumberInput from "web/components/form-elements/NumberInput";
import DatePicker from 'web/components/DatePicker';
import SpecificationDetails from 'web/components/SpecificationDetails';
import Select from 'web/components/form-elements/Select';
import { adminFlatFeeAddApi, adminFlatFeeUpdateApi } from 'redux/actions/adminPtPlus/index';
import { InputFieldsWrapper } from '.././PTPlusStyled'
import AlertModal from 'web/components/AlertModal';
import CloseIcon from "web/assets/images/CloseIcon.png";
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';


function FlatFeeAdditionModal(pageProps) {
  const dispatch = useDispatch();
  let history = useHistory()
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const [saveDisableState, setSaveDisableState] = useState(true)

  const [alertType, setAlertType] = useState()

  let currencyList = [{ value: "USD", label: 'USD' }]

  const [locationTypeList, setLocationTypeList] = useState([])

  useEffect(() => {
    let rateFromDate = new Date();
    let rateToDate = new Date();
    let oneMonth = rateToDate.setMonth(rateToDate.getMonth() + 1)
    rateToDate = new Date(oneMonth);

    let locationsDetailsTemp = []
    locationsDetailsTemp = pageProps.locationsList?.map(val => {
      return (
        {
          name: val.address.locationName,
          label: `${val.address.locationName}, ${val.address.city}, ${val.address.state}`,
          value: val.locationId
        }
      )
    })
    setLocationTypeList(locationsDetailsTemp)
  }, [])

  useEffect(() => {
    let fieldValues = pageProps.formikProps.values
    if (pageProps.formikProps.errors?.rateExpDate || pageProps.formikProps.errors?.rateStartDate) setSaveDisableState(true)
    else if (fieldValues.addLocationInput === '' || fieldValues.flatFeeValue === '') setSaveDisableState(true)
    else setSaveDisableState(false)
  }, [pageProps.formikProps])

  const addFlatFeeFunction = async () => {
    let fieldValues = pageProps.formikProps.values
    let editedFlatFeeValues = pageProps.editDatas

    if ((fieldValues.grade === "Custom" || fieldValues.size === "Custom" || fieldValues.material === "OTHER" || fieldValues.material === "PLASTIC") && (!fieldValues.length || !fieldValues.width || !fieldValues.height)) {
      setAlertModalContent("Custom size is required.");
      setAlertModal(!alertModal)
      return false;
    }
    let conditionArr = [];
    if (fieldValues.condition0) {
      conditionArr.push("RECYCLED");
    }
    if (fieldValues.condition1) {
      conditionArr.push("NEW");
    }
    if (fieldValues.condition2) {
      conditionArr.push("COMBO");
    }
    if (fieldValues.condition3) {
      conditionArr = []
      conditionArr.push("CORES");
    }

    let hardSoftWoodValue = undefined
    if (fieldValues.material === 'WOOD' && fieldValues.condition1) {
      if (fieldValues.hardOrSoftWood === 'New - Hardwood') hardSoftWoodValue = 'HARDWOOD'
      else if (fieldValues.hardOrSoftWood === 'New - Softwood') hardSoftWoodValue = 'SOFTWOOD'
    }

    if (conditionArr.length === 0 && fieldValues.material !== "OTHER") {
      setAlertModalContent("Condition field is required.");
      setAlertModal(!alertModal)
      return false;
    }
    else if (fieldValues.material === "WOOD" && !fieldValues.palletType) {
      setAlertModalContent("Pallet Type field is required.");
      setAlertModal(!alertModal)
      return false;
    }
    else if (fieldValues.material === "WOOD" && fieldValues.palletType && !fieldValues.size) {
      setAlertModalContent("Size field is required.");
      setAlertModal(!alertModal)
      return false;
    }
    else if (fieldValues.grade === null) {
      setAlertModalContent("Grade field is required.");
      setAlertModal(!alertModal)
      return false;
    }

    let response = ''
    let selectedId = locationTypeList.filter(val => val.value === fieldValues.addLocationInput)
    let name = selectedId[0].name
    if (fieldValues.flatFeeValue === 0 || fieldValues.flatFeeValue === '0') {
      setAlertModalContent("Flat fee should not be zero.")
      setAlertModal(!alertModal)
    } else if (fieldValues.length === '0' || fieldValues.width === '0' || fieldValues.height === '0') {
      setAlertModalContent("Size should not be zero.")
      setAlertModal(!alertModal)
    } else {
      let data = {
        locationId: fieldValues.addLocationInput,
        locationName: name,
        fee: fieldValues.flatFeeValue,
        active: true,
        currency: fieldValues.flatFeeCurrencyLists,
        rateStartDate: moment(fieldValues.rateStartDate).format('YYYY-MM-DD HH:mm'),
        rateExpirationDate: moment(fieldValues.rateExpDate).format('YYYY-MM-DD HH:mm'),
        palletDetails: {
          material: fieldValues.material, //WOOD("WOOD", 1), PLASTIC("PLASTIC", 2), OTHER("OTHER", 3);
          condition: conditionArr, //RECYCLED("RECYCLED", 1), NEW("NEW", 2), COMBO("COMBO", 3),CORES("CORES", 4);
          // palletType: fieldValues.palletType, //BLOCK, STRINGER, EURO_PALLET, CRATE, TRAY, GREEN_35, KILN_DRY_19, KILN_DRY_15 
          palletType: fieldValues.palletType ? fieldValues.palletType.toUpperCase() : "CUSTOM",
          moisture: fieldValues.moisture,
          size: fieldValues.size,
          grade: fieldValues.grade,
          heatTreared: fieldValues.isHeatTreared,
          length: fieldValues.length ? parseFloat(fieldValues.length) : "",
          width: fieldValues.width ? parseFloat(fieldValues.width) : "",
          height: fieldValues.height ? parseFloat(fieldValues.height) : "",
        },
        equipment: fieldValues.isLtl ? 'LTL' : 'FTL',
        comment: fieldValues.comment
      }
      if (hardSoftWoodValue) {
        data.palletDetails['newConditionType'] = hardSoftWoodValue
      }
      const token = localStorage.getItem('token')
      if (!localStorage.getItem("token")) {
        adminLogout()
      } else {
        if (fieldValues.flatFeeSpecEdit) response = await dispatch(adminFlatFeeUpdateApi(editedFlatFeeValues?.flatFeeId, data, token))
        else response = await dispatch(adminFlatFeeAddApi(fieldValues.addLocationInput, data, token))
        if (response?.success) {
          setAlertModalContent(response?.data?.msg)
          setAlertModal(!alertModal)
          setAlertType("success")
          pageProps.fetchLocationsListFunction()
        } else {
          if (response?.statusCode === 401) {
            adminLogout()
          } else {
            setAlertModalContent(response?.data?.error?.message)
            setAlertModal(!alertModal)
          }
        }
      }
    }

  }
  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}))
    dispatch(logoutAdmin())
    localStorage.removeItem('adminRolesData')
    localStorage.removeItem('adminName')
    localStorage.removeItem('adminEmail')
    localStorage.removeItem('token')
    history.push('./sign-in')
    window.location.reload(false);
  }

  const clearFields = () => {
    pageProps.setFieldValue("rateStartDate", moment().format('MM/DD/YYYY'));
    pageProps.setFieldValue("rateExpDate", moment().add(12, 'months').format('MM/DD/YYYY'));
    pageProps.setFieldValue("material", "WOOD")
    pageProps.setFieldValue("palletType", "")
    pageProps.setFieldValue("condition0", "")
    pageProps.setFieldValue("condition1", "")
    pageProps.setFieldValue("condition2", "")
    pageProps.setFieldValue("condition3", "")
    pageProps.setFieldValue("moisture", "")
    pageProps.setFieldValue("size", "")
    pageProps.setFieldValue("grade", "")
    pageProps.setFieldValue("length", "")
    pageProps.setFieldValue("width", "")
    pageProps.setFieldValue("height", "")
    pageProps.setFieldValue("isHeatTreared", false)
    pageProps.setFieldValue("isLtl", false)
    pageProps.setFieldValue("comment", "")
  }
  return (
    <>
      {loaderVisible && <Spinner />}
      <div>
        <div className="modal-header-style">
          <h6>Flat Fee</h6>
          <img src={CloseIcon} alt="close-icon" onClick={() => {
            clearFields()
            pageProps.toggle()
          }} />
        </div>


        <div style={{ padding: '25px 15px 0px', 'padding-bottom': '0px' }}>
          <InputFieldsWrapper>
            <div className="row">
              <div className="col-md-6">
                {/* <TextInput name='addLocationInput' placeholder={`Location Name*`} inputType='text' /> */}
                <Select
                  name='addLocationInput'
                  placeholder='Select Location'
                  data={locationTypeList}
                  disabled={pageProps.formikProps?.values?.flatFeeSpecEdit}
                  onChangeHandler={() => {
                  }}
                />
              </div>
              <div className={pageProps.formikProps?.values?.flatFeeSpecEdit ? "bordered-input input-disabled col-md-3" : "bordered-input col-md-3"}>
                <NumberInput name='flatFeeValue' placeholder='0.00' decimalScale={2}
                  disabled={pageProps.formikProps?.values?.flatFeeSpecEdit} />
              </div>
              <div className="col-md-3">
                <Select
                  name='flatFeeCurrencyLists'
                  data={currencyList}
                  disabled
                  onChangeHandler={() => {
                  }}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6 date-border-adjust">
                <Field name='rateStartDate'>
                  {({ field, meta, form }) => {
                    return (
                      <div className='app-input-text'>
                        <h6 className='mb-2'>Rate Start Date<span className='star'>&#42;</span></h6>
                        <DatePicker
                          name='rateStartDate'
                          maxDOBirth={pageProps?.formikProps?.values?.rateExpDate}
                          value={pageProps?.formikProps?.values?.rateStartDate}
                          type="flatFeeForm"
                          callBackFun={(date, value) => {
                            form.setFieldValue('rateStartDate', date)
                          }}
                        />
                        {form?.errors?.rateStartDate && <p className="error-message">{form?.errors.rateStartDate}</p>}
                      </div>
                    );
                  }}
                </Field>
              </div>
              <div className="col-md-6 date-border-adjust">
                <Field name='rateExpDate'>
                  {({ field, meta, form }) => {
                    return (
                      <div className='app-input-text'>
                        <h6 className='mb-2'>Rate Expiration Date<span className='star'>&#42;</span></h6>
                        <DatePicker
                          name='rateExpDate'
                          minDOBirth={pageProps?.formikProps?.values?.rateStartDate}
                          value={pageProps?.formikProps?.values?.rateExpDate}
                          type="flatFeeForm"
                          callBackFun={(date, value) => {
                            form.setFieldValue('rateExpDate', date)
                          }}
                        />
                        {form?.errors?.rateExpDate && <p className="error-message">{form?.errors.rateExpDate}</p>}
                      </div>
                    );
                  }}
                </Field>
              </div>
            </div>
          </InputFieldsWrapper>
        </div>

        <div className="specfiles-wrapper" style={{ padding: '25px 15px 0px', 'padding-top': '0' }}>
          <SpecificationDetails formikProps={pageProps.formikProps} setFieldValue={pageProps.setFieldValue} getValue={pageProps.editDatas} />
        </div>
        <div className="specfiles-wrapper" style={{ padding: '25px 15px 0px', 'padding-top': '0' }}>
          <div className="my-2">
            <p style={{ "font-weight": "bold" }}>Comment</p>
          </div>
          <TextArea
            name="comment"
            maxLength="200"
            showErrorMessages={true}
          />
        </div>

        <InputFieldsWrapper>
          <div style={{ display: 'flex', justifyContent: 'center', 'margin-bottom': '20px' }}>
            <button className='green-button' style={{ opacity: saveDisableState ? 0.5 : 1 }} disabled={saveDisableState}
              onClick={addFlatFeeFunction}>{pageProps.formikProps?.values?.flatFeeSpecEdit ? 'Update' : 'Submit'}</button>
          </div>
        </InputFieldsWrapper>
      </div>
      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType={alertType}
        callBackAlert={(val) => {
          if (val === "success") {
            clearFields()
            pageProps.toggle()
          }
        }}
      />
    </>
  );
}

export default FlatFeeAdditionModal;
